export class RbsDataDto {
  constructor(data) {
    this.last_name = data.last_name;
    this.server_id = data.server_id;
    this.user_id = data.user_id;
  }
}
